var map = {
	"./admin.js": "6a86",
	"./basic.js": "9437",
	"./block.js": "2d5b",
	"./category.js": "5417",
	"./categoryAdmin.js": "2e2a",
	"./channel.js": "94b4",
	"./comment.js": "9cbf",
	"./commentAdmin.js": "9993",
	"./content.js": "2ccc",
	"./gaode.js": "2ba7",
	"./group.js": "cfbb",
	"./index.js": "c270",
	"./krpano.js": "b229",
	"./label.js": "5daa",
	"./material.js": "b533",
	"./media.js": "27e4",
	"./message.js": "5252",
	"./option.js": "cccd",
	"./point.js": "c759",
	"./polyline.js": "e43c",
	"./region.js": "1649",
	"./regionAdmin.js": "9344",
	"./setting.js": "f6fa",
	"./shop.js": "ed68",
	"./spot.js": "ce31",
	"./storage.js": "c04c",
	"./subject.js": "b81e",
	"./user.js": "43b5",
	"./userAdmin.js": "05d0",
	"./vr.js": "a2c3",
	"./works.js": "7acd",
	"./worksAdmin.js": "a229"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f008";